//@flow
import React, { useEffect, useState } from 'react';
import { HTMLView } from 'components/atoms/htmlView';
import { Image } from 'components/atoms/image';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { CallToAction } from 'components/atoms/callToAction';
import { OverlayPortal } from 'components/templates/overlayPortal';
import { OverlayModal } from 'components/templates/overlayModal';
import { RouteNames } from 'router';

type Props = {
  heading?: string,
  subHeading?: string,
  description?: string,
};

const FoundationMobile = (props: Props) => {
  const { cmsDetailsData } = props;
  const {
    heading,
    tagWord,
    description_mobile,
    image_mobile,
  } = props.data.foundationSection[0];
  const [selected_heading, set_selected_heading] = useState('');
  const [selected_title, set_selected_title] = useState('');
  const [showDescriptionLayout, setshowDescriptionLayout] = useState(false);
  const [overlay_page_data, set_overlay_page_data] = useState({});
  useEffect(() => {
    if (cmsDetailsData) {
      checkOverlayCorrespondingFeature();
    }
  }, [selected_heading]);
  const mediaPath = `${props.mediaPath}${'/mobile'}`;
  const checkOverlayCorrespondingFeature = () => {
    let overlaydata = {};
    set_overlay_page_data(overlaydata);
    Object.values(cmsDetailsData).map((cmsdata, idx) => {
      if (heading === cmsdata.page_title) {
        set_overlay_page_data(cmsdata);
        set_selected_title(cmsdata.page_title);
        return;
      }
    });
  };
  const handleLearnMore = heading => {
    set_selected_heading(heading);
    checkOverlayCorrespondingFeature();
    setshowDescriptionLayout(true);
  };
  const handleClick = () => {
    console.log('');
  };
  const showOverlay = showDescriptionLayout ? (
    <OverlayPortal>
      <OverlayModal
        data={overlay_page_data}
        theme={'light-theme'}
        type={'description-overlay'}
        openFor={'leadership'}
        className={'ourHomesOverlay'}
        mediaPath={mediaPath}
        onClosePress={() => setshowDescriptionLayout(false)}
        breadcrumbList={[
          {
            breadcrumbName: 'Music & Events',
            breadcrumbLink: RouteNames.musicEvents,
          },
          {
            breadcrumbName: 'Music Foundation',
            breadcrumbLink: '#',
          },
        ]}
      />
    </OverlayPortal>
  ) : null;

  return (
    <div className={'main-section'}>
      <h2 className={'headingClassName'}>{heading}</h2>
      <div className={'foundation-mob'}>
        <Image
          src={image_mobile}
          alt={'FoundationPic'}
          className={'foundation-image'}
        />
      </div>
      <div>
        <h2 className={'subHeadingClassName'}>{tagWord}</h2>
        <div className={'description'}>
          <HTMLView
            className={'descriptionClassName'}
            html={description_mobile}
            tagName={'p'}
          />
        </div>
      </div>
      {props.showOverlay === true && heading === selected_title ? (
        <div className="learn-more">
          <CallToAction
            onClick={() => handleLearnMore(heading)}
            text={'Learn More'}
            mode={'transparent'}
            type={'link'}
            size={'small'}
          />
        </div>
      ) : null}
      {props.type === 'restaurant' && (
        <a href={'#contact'}>
          <div className="learn-more">
            <CallToAction
              onClick={() => handleClick()}
              text={'Contact Us'}
              mode={'transparent'}
              type={'link'}
              size={'small'}
            />
          </div>
        </a>
      )}
      {showOverlay}
    </div>
  );
};
export default FoundationMobile;
